import { render, staticRenderFns } from "./fshow.vue?vue&type=template&id=004af826&"
import script from "./fshow.vue?vue&type=script&lang=js&"
export * from "./fshow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports